import { jsx as _jsx } from "react/jsx-runtime";
import { useMediaQuery, useTheme } from "@mui/material";
import { PlusMinusControl } from "./PlusMinusControl";
import { SingleSelectControl } from "./SingleSelectControl";
export const CardQuantityControl = ({ hideControls, isSingleSelect, quantity, isSelectDisabled, selectedText, unselectedText, isAddDisabled, isMinusDisabled, isCustomizeModal, openModalOnMinusClick, openModalOnPlusClick, handleOpenCustomizeTab, handleCustomizeIncrement, handleCustomizeDecrement, handleToggle, handleQuantityDecrement, handleQuantityIncrement, openCustomizeModal, }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"), { noSsr: true });
    if (hideControls)
        return null;
    if (isSingleSelect) {
        return (_jsx(SingleSelectControl, { onClick: () => {
                // Open the customize modal if the openCustomizeModal function is provided and the quantity is 0.
                if (!isCustomizeModal && openCustomizeModal && quantity === 0) {
                    openCustomizeModal();
                    return;
                }
                // If we don't need to open the customize modal, we just call the toggle function.
                else if (handleToggle) {
                    handleToggle();
                    return;
                }
            }, selected: quantity > 0, disabled: isSelectDisabled, selectedText: selectedText, unselectedText: unselectedText }));
    }
    else {
        return (_jsx(PlusMinusControl, { handleAddClick: () => {
                if (openCustomizeModal && ((!isCustomizeModal && quantity === 0) || openModalOnPlusClick)) {
                    openCustomizeModal();
                    return;
                }
                if (isCustomizeModal && handleCustomizeIncrement) {
                    // Should set assignmentId when quantity is 0 because we're creating a new assignment
                    handleCustomizeIncrement(quantity === 0);
                    return;
                }
                if (!isCustomizeModal && handleQuantityIncrement && !openModalOnPlusClick) {
                    handleQuantityIncrement(false, false);
                    return;
                }
            }, handleMinusClick: () => {
                //If there are multiple unique assignments we need to open the ItemDetailDialog so the customer can choose which to remove
                if (openModalOnMinusClick && handleOpenCustomizeTab) {
                    handleOpenCustomizeTab();
                    return;
                }
                if (quantity > 0 && isCustomizeModal && handleCustomizeDecrement) {
                    handleCustomizeDecrement();
                    return;
                }
                if (quantity > 0 && !isCustomizeModal && handleQuantityDecrement) {
                    handleQuantityDecrement();
                    return;
                }
            }, quantity: quantity, isAddDisabled: isAddDisabled, isMinusDisabled: isMinusDisabled, size: isMobile ? "small" : "medium" }));
    }
};
